export const SCENSUM_WEBSITE_HEADER_HEIGHT = "70px";
export const BFC_PROGRESS_BAR_HEIGHT_MOBILE = "35px";
export const BFC_PREVIEW_BAR_THUMB_SIZE = "56px";

// Area permanently covered by the fixed header and navbar on mobile.
export const BFC_FIXED_CHROME_HEIGHT_MOBILE =
  parseInt(SCENSUM_WEBSITE_HEADER_HEIGHT, 10) +
  parseInt(BFC_PROGRESS_BAR_HEIGHT_MOBILE, 10);

export const BFC_SPA_Uterum = "BFC_SPA_Uterum";
